<template>
    <div class="goods-info">
        <div class="icon" v-if="showVipGoodsIcon(groupVipGoodsInfo) === 'vip1'"></div>
        <div class="inner" :class="[`${showVipGoodsIcon(groupVipGoodsInfo)}`]">
            <div class="dv1">
                {{ groupVipGoodsInfo.name }}
            </div>
            <div class="dv2">
                <!-- 优先按照"原价展示渠道"逻辑展示价格 -->
                <template v-if="groupVipGoodsInfo.showOriginPrice">
                    <span class="sp1">
                        <i class="i0">仅售</i>
                        <i class="i1">¥</i>
                        <i class="i2">{{ groupVipGoodsInfo.original_price }}</i>
                    </span>
                </template>
                <template v-else>
                    <span class="sp1">
                        <i class="i0">仅售</i>
                        <i class="i1">¥</i>
                        <i class="i2">{{ groupVipGoodsInfo.current_price }}</i>
                    </span>
                    <span class="sp2" v-if="groupVipGoodsInfo.original_price * 100 !== groupVipGoodsInfo.current_price * 100 && groupVipGoodsInfo.original_price * 100 > groupVipGoodsInfo.current_price * 100">
                        <i>原价</i>
                        <i>{{ groupVipGoodsInfo.original_price }}</i>
                    </span>
                </template>
            </div>
            <div class="dv4">全场游戏免费畅玩尊享{{ groupVipGoodsInfo.name }}</div>
        </div>
    </div>
</template>
<script>
import Decimal from 'decimal.js'

export default {
    name: 'GroupGoodsInfo',
    props: {
        groupVipGoodsInfo: {
            type: Object,
            default: () => ({})
        }
    },
    computed: {
        showVipGoodsIcon() {
            return (item) => {
                let className = ''
                if (!item.name) {
                    className = ''
                } else if (item.name.indexOf('永久会员') > -1) {
                    className = 'vip1'
                } else if (item.name.indexOf('365天会员') > -1) {
                    className = 'vip2'
                } else if (item.name.indexOf('30天会员') > -1) {
                    className = 'vip3'
                }
                return className
            }
        },
        subsidyPrice() {
            return (item) => {
                if (!item.id) {
                    return 0
                }
                const payPrice = item.showOriginPrice ? item.original_price : item.current_price
                return Math.abs(new Decimal(payPrice).minus(new Decimal(item.group_price)).toNumber())
            }
        }
    }
}
</script>
<style lang="less" scoped>
.goods-info {
    position: relative;
    width: 282px;
    margin-right: 36px;
    flex-shrink: 0;

    .icon {
        position: absolute;
        z-index: 1;
        top: -18px;
        right: -11px;
        width: 88px;
        height: 64px;
        background: url(../../../assets/act/diamond-m-icon.png) center/100% no-repeat;
    }

    .inner {
        position: relative;
        width: 262px;
        height: 137px;

        &.vip1 {
            background: url(../../../assets/act/vip1-m.png) left top no-repeat;

            .dv1 {
                background: linear-gradient(90deg, #a45d1b 4.91%, #835d39 99.84%);
                background-clip: text;
                -webkit-background-clip: text;
                -webkit-text-fill-color: transparent;
            }

            .dv2 {
                .sp1 {
                    color: #a45d1b;
                }

                .sp2 {
                    color: rgba(164, 93, 27, 0.5);

                    &::after {
                        background-color: rgba(164, 93, 27, 0.5);
                    }
                }
            }

            .dv4 {
                color: rgba(164, 93, 27, 0.8);
                border: 1px solid #e6ad5c;
            }
        }

        &.vip2 {
            background: url(../../../assets/act/vip2-m.png) left top no-repeat;

            .dv1 {
                background: linear-gradient(90deg, #ffe4ca 2.34%, #fffefd 100%);
                background-clip: text;
                -webkit-background-clip: text;
                -webkit-text-fill-color: transparent;
            }

            .dv2 {
                .sp1 {
                    color: #ffe5cd;
                }

                .sp2 {
                    color: #ffe4ca;

                    &::after {
                        background-color: #ffe4ca;
                    }
                }
            }

            .dv4 {
                color: #8a95b2;
                border: 1px solid #808aa2;
            }
        }

        &.vip3 {
            background: url(../../../assets/act/vip3-m.png) left top no-repeat;

            .dv1 {
                color: rgb(119, 95, 201);
            }

            .dv2 {
                .sp1 {
                    color: #775fc9;
                }

                .sp2 {
                    color: rgba(119, 95, 201, 0.5);

                    &::after {
                        background-color: rgba(119, 95, 201, 0.5);
                    }
                }
            }

            .dv4 {
                color: rgba(119, 95, 201, 0.8);
                border: 1px solid #afa6e9;
            }
        }

        .dv1 {
            padding-top: 21px;
            text-align: center;
            font-size: 16px;
            font-weight: 700;
        }

        .dv2 {
            margin-top: 4px;
            text-align: center;

            .sp1 {
                .i0 {
                    position: relative;
                    font-size: 12px;
                    line-height: 18px;
                    margin: 0 8px;
                    top: -1px;
                }

                .i1 {
                    font-size: 14px;
                    font-weight: 700;
                    line-height: 21px;
                    margin-right: 4px;
                }

                .i2 {
                    margin-right: 4px;
                    font-size: 36px;
                    font-style: normal;
                    font-weight: 900;
                }
            }

            .sp2 {
                position: relative;
                font-size: 12px;
                font-weight: 400;
                line-height: 18px;

                i:first-child {
                    margin-right: 4px;
                }

                &::after {
                    position: absolute;
                    top: 50%;
                    left: 50%;
                    transform: translate(-50%);
                    content: '';
                    width: 105%;
                    height: 1px;
                }
            }
        }

        .dv4 {
            position: absolute;
            width: 214px;
            height: 20px;
            left: 50%;
            transform: translateX(-50%);
            bottom: 15px;
            border-radius: 4px;
            font-size: 12px;
            text-align: center;
            line-height: 20px;
        }
    }
}
</style>
